import { Module } from 'vuex';
import { IDocument } from '@/types/Document';
import { IDocumentPage } from '@/types/document-page';
import { IUser } from '@/types/User';
import { RootState } from '@/store/store';
import { actions } from '@/dealroom/store/dealroom.actions';
import { actions as editorActions } from '@/editor/editor-block/store/editor-content.actions';
import { getters } from '@/dealroom/store/dealroom.getters';
import { getters as editorGetters } from '@/editor/editor-block/store/editor-content.getters';
import { mutations } from '@/dealroom/store/dealroom.mutations';
import { mutations as editorMutations } from '@/editor/editor-block/store/editor-content.mutations';
import { IWordMerge } from '@/dealroom/types/word-merge';
import { IPreviewToken } from '@/dealroom/document/types/preview-token';
import { contentLink } from '@/dealroom/content-link/store/content-link.store';
import { EWindowSize } from '@/enums/window-size';
import { isWindowSize } from '@/helpers/window-size.helper';
import { addPage } from '@/dealroom/add-page/store/add-page.store';

export const namespace: string = 'dealroom';
const namespaced: boolean = true;

export interface IDealroomState {
  loading: boolean;
  loaded: boolean;
  showDocumentSettings: boolean;
  createDocumentId: string;
  document: IDocument;
  currentDocumentPage: IDocumentPage;
  selectedUser: IUser;
  selectedRecipient: { id: string; connectFirstRecipient: boolean };
  wordMerge: IWordMerge;
  previewToken: IPreviewToken;
  sealValidationSuccess: boolean;
  sidebarCollapsed: boolean;
}

export const state: IDealroomState = {
  loading: false,
  loaded: false,
  showDocumentSettings: false,
  document: undefined,
  currentDocumentPage: undefined,
  createDocumentId: undefined,
  selectedUser: null,
  selectedRecipient: { id: null, connectFirstRecipient: null },
  wordMerge: {
    missing: [],
    filename: '',
    index: 0,
    isDynamic: true,
  },
  previewToken: {
    jwt: null,
    exp: null,
  },
  sealValidationSuccess: null,
  sidebarCollapsed: isWindowSize(EWindowSize.Small),
};

export const dealroom: Module<IDealroomState, RootState> = {
  state,
  actions: { ...actions, ...editorActions },
  mutations: { ...mutations, ...editorMutations },
  getters: { ...getters, ...editorGetters },
  namespaced,
  modules: {
    addPage,
    contentLink,
  },
};
